// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 升级 POST /update/run */
export async function postUpdateRun(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.postUpdateRunParams,
  options?: { [key: string]: any },
) {
  return request<string>('/update/run', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
